import { IntegrationsRoutes } from './partners/integrations';
import { StoreRoutes } from './partners/store';
import APIRoutes from './web/api';
import { CommerceRoutes } from './web/commerce';
import PublicRoutes from './web/public';
import UserRoutes from './web/user';

export * from './domain';

export const withSearchParams = (path: string, searchParams: Record<string, string>) => {
	const searchParamsString = new URLSearchParams(searchParams).toString();
	return `${path}${searchParamsString ? `?${searchParamsString}` : ''}`;
};

export const WebRoutes = {
	...PublicRoutes,
	...UserRoutes,
	...APIRoutes,
	...CommerceRoutes,
} as const;

export const PartnerRoutes = {
	Store: StoreRoutes,
	Integrations: IntegrationsRoutes,
} as const;

export { CrewRoutes } from './crew';
